// extracted by mini-css-extract-plugin
export default {"afnicLogo":"oqmed0","afnicHeading":"_AUali"};